var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5Support = function SvgAv5Support(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-variant": "menu-icon"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#9B9AC8",
    className: "menu-background",
    "data-no-stroke": "true"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "menu-vectors"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.001 25.027c-.479 0-.912-.285-1.097-.726a1.184 1.184 0 0 1 1.543-1.547c.441.185.73.618.73 1.097 0 .648-.528 1.176-1.18 1.176h.004Z",
    fill: "#fff",
    "data-no-stroke": "true"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12a5 5 0 1 1 5.994 4.901c-.542.11-.994.547-.994 1.099v2",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    "data-no-fill": "true"
  }))));
};
export { SvgAv5Support as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMzIgMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZGF0YS12YXJpYW50PSJtZW51LWljb24iPgogICAgPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iNiIgZmlsbD0iIzlCOUFDOCIgY2xhc3M9Im1lbnUtYmFja2dyb3VuZCIgZGF0YS1uby1zdHJva2U9InRydWUiLz4KICAgIDxnIGNsYXNzPSJtZW51LXZlY3RvcnMiPgogICAgICAgIDxwYXRoCiAgICAgICAgICAgIGQ9Ik0xNi4wMDEyIDI1LjAyN0MxNS41MjI1IDI1LjAyNyAxNS4wODkzIDI0Ljc0MjQgMTQuOTAzNiAyNC4zMDA5QzE0LjcxOCAyMy44NTk0IDE0LjgyMTEgMjMuMzUxOSAxNS4xNTk1IDIzLjAwOTRDMTUuNDk3OCAyMi42NzExIDE2LjAwNTMgMjIuNTcyMSAxNi40NDY4IDIyLjc1MzZDMTYuODg4MyAyMi45MzkzIDE3LjE3NzEgMjMuMzcyNSAxNy4xNzcxIDIzLjg1MTFDMTcuMTc3MSAyNC40OTg5IDE2LjY0ODkgMjUuMDI3IDE1Ljk5NyAyNS4wMjdIMTYuMDAxMloiCiAgICAgICAgICAgIGZpbGw9IndoaXRlIgogICAgICAgICAgICBkYXRhLW5vLXN0cm9rZT0idHJ1ZSIKICAgICAgICAvPgogICAgICAgIDxwYXRoCiAgICAgICAgICAgIGQ9Ik0xMSAxMkMxMSA5LjIzODU4IDEzLjIzODYgNyAxNiA3QzE4Ljc2MTQgNyAyMSA5LjIzODU4IDIxIDEyQzIxIDE0LjQyMTIgMTkuMjc5IDE2LjQ0MDUgMTYuOTkzNiAxNi45MDEzQzE2LjQ1MjIgMTcuMDEwNCAxNiAxNy40NDc3IDE2IDE4VjIwIgogICAgICAgICAgICBzdHJva2U9IndoaXRlIgogICAgICAgICAgICBzdHJva2Utd2lkdGg9IjEuNSIKICAgICAgICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgICAgICAgICBkYXRhLW5vLWZpbGw9InRydWUiCiAgICAgICAgLz4KICAgIDwvZz4KPC9zdmc+";